module.exports = __webpack_public_path__ + "static/image/PFWB.2eb2885.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/PFWB.png
// module id = 383
// module chunks = 1